export default {
    title: 'Profilo',
    subtitle: 'Gestisci le tue informazioni personali e preferenze',
    tabs: {
        preferences: 'Preferenze',
        account: 'Account',
        password: 'Password',
        picture: 'Foto Profilo',
        companies: 'Aziende',
        integrations: 'Integrazioni',
    },
    preferences: {
        language: {
            title: 'Lingua',
            description: 'Seleziona la tua lingua preferita per l\'interfaccia',
        },
        theme: {
            title: 'Tema',
            description: 'Scegli tra tema chiaro e scuro',
        },
    },
    account: {
        title: 'Informazioni Account',
        description: 'Aggiorna le tue informazioni personali',
        legalSection: {
            title: 'Legale',
            description: 'Consulta i nostri Termini e condizioni e la Privacy Policy.',
        },
        firstName: 'Nome',
        firstNamePlaceholder: 'Inserisci il tuo nome',
        lastName: 'Cognome',
        lastNamePlaceholder: 'Inserisci il tuo cognome',
        email: 'Email',
        emailPlaceholder: 'Inserisci il tuo indirizzo email',
        phone: 'Telefono',
        phonePlaceholder: 'Inserisci il tuo numero di telefono',
        jobTitle: 'Ruolo',
        jobTitlePlaceholder: 'Inserisci il tuo ruolo',
        department: 'Dipartimento',
        departmentPlaceholder: 'Inserisci il tuo dipartimento',
    },
    password: {
        title: 'Cambia Password',
        description: 'Aggiorna la password del tuo account',
        currentPassword: 'Password Corrente',
        currentPasswordPlaceholder: 'Inserisci la tua password corrente',
        newPassword: 'Nuova Password',
        newPasswordPlaceholder: 'Inserisci la tua nuova password',
        confirmPassword: 'Conferma Password',
        confirmPasswordPlaceholder: 'Conferma la tua nuova password',
        mismatch: 'Le password non corrispondono',
        changePassword: 'Cambia Password',
    },
    picture: {
        title: 'Foto Profilo',
        description: 'Carica e gestisci la tua foto profilo',
        global: 'Globale (Tutte le Aziende)',
        scope: 'Ambito',
        scopeDescription: 'Scegli se questa immagine deve essere visibile globalmente o solo per un\'azienda specifica',
        selectFile: 'Seleziona File',
        upload: 'Carica',
        invalidFileType: 'Tipo di file non valido. Seleziona un\'immagine PNG, JPG, JPEG o WEBP.',
        fileTooLarge: 'La dimensione del file supera il limite di 5MB.',
    },
    companies: {
        title: 'Aziende',
        description: 'Visualizza tutte le aziende di cui fai parte',
        noCompanies: 'Non fai parte di nessuna azienda',
        primary: 'Principale',
        noType: 'Nessun Tipo',
        types: {
            sender: 'Mittente',
            receiver: 'Destinatario',
            freight_forwarder: 'Spedizioniere',
            port_authority: 'Autorità Portuale',
            carrier: 'Vettore',
            customs_broker: 'Spedizioniere Doganale',
            insurance_provider: 'Fornitore di Assicurazioni',
        },
        role: {
            super_admin: 'Super Admin',
            company_admin: 'Admin Azienda',
            operator: 'Operatore',
            viewer: 'Visualizzatore',
        },
    },
    integrations: {
        title: 'Integrazioni Email',
        description: 'Collega i tuoi account Gmail o Outlook personali a Eve Mind',
        connectedAccounts: 'Account Collegati',
        connectNew: 'Collega Nuovo Account',
        connectGmail: 'Collega Gmail',
        connectOutlook: 'Collega Outlook',
        confirmDisconnect: 'Sei sicuro di voler disconnettere questo account email?',
        providers: {
            gmail: 'Gmail',
            outlook: 'Outlook',
        },
        status: {
            active: 'Attivo',
            inactive: 'Inattivo',
            error: 'Errore',
            authentication_required: 'Autenticazione Richiesta',
        },
        tracking: {
            title: 'Tracking Container',
            description: 'Configura gli aggiornamenti automatici del tracking per le tue spedizioni',
            autoRefresh: 'Aggiornamenti Automatici',
            autoRefreshDescription: 'Abilita gli aggiornamenti automatici dello stato del tracking',
            dailyUpdates: 'Aggiornamenti Giornalieri',
            dailyUpdatesDescription: 'Numero di aggiornamenti tracking al giorno',
            updateTime: 'Orario Aggiornamento (UTC)',
            updateTimeDescription: 'Orario in cui viene eseguito l\'aggiornamento giornaliero del tracking',
            saveSuccess: 'Impostazioni tracking salvate con successo',
            saveError: 'Impossibile salvare le impostazioni tracking',
            loadError: 'Impossibile caricare le impostazioni tracking',
        },
    },
};

